import { PixelRatioImage, type PixelRatioImageProps } from "@/components/common/pixel-ratio-image";
import ImageRule1 from "@/assets/custom-digital-human-rule/image_rule_4.webp";
import ImageRule2 from "@/assets/custom-digital-human-rule/image_rule_4@2x.webp";
import ImageRule3 from "@/assets/custom-digital-human-rule/image_rule_4@3x.webp";

export const ImageRule4Image = (props: Omit<PixelRatioImageProps, "images">) => {
  return (
    <PixelRatioImage
      images={[ImageRule3]}
      {...props}
    />
  );
};

ImageRule4Image.displayName = 'ImageRule4Image';
